module.exports = __webpack_public_path__ + "img/amex.fc9db59c.png";